import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";

import App from "./App";
import "./index.css";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.headers.common["x-Api-Key"] = process.env.REACT_APP_API_KEY;
axios.defaults.headers.common["Content-Type"] = "application/json";

axios.interceptors.request.use(request => {
    console.log(request);
    // Edit request config
    return request;
}, error => {
    console.log(error);
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    console.log(response);
    // Edit request config
    return response;
}, error => {
    console.log(error);
    return Promise.reject(error);
});

ReactDOM.render(<App />, document.getElementById("root"));